<template>
  <v-dialog v-model="is_auto_sync_dialog_first_open" width="550" persistent>
    <v-card class="secure-modal proceed-modal csv-file-modal">
      <v-card-title class="text-h5  ">
				<v-card-actions class="close-icon">
					<v-btn color="primary" text @click="closeDialogFirst()">
					   <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
					   </v-btn>
				</v-card-actions>
			</v-card-title>
      <v-card-text v-if="dashboardType != 'retirement'">
        <p>With <b>“Auto Track”</b> your investments in equities, bonds & mutual funds will be automatically updated. The market price of your investments will be updated daily. </p>
        <p>You need to sync emails where you receive CDSL/NSDL eCAS statement or trades executed at NSE/BSE for each member and start auto tracking your portfolio.</p>
        <p>You will receive emails from <b>eCAS@cdslstatement.com</b> with Subject line – “CDSL Consolidated Account Statement (CAS) across Mutual Funds and Depositories for JAN2022.” or <b class="tex_color">NSDL-CAS@nsdl.co.in</b> with subject line – “NSDL Consolidated Account Statement (CAS)” or NSE – Direct – “Trades executed at NSE” or BSE ALERTS - “Details of your BSE trade”</p>
        <p>You have to enable read permission for your email ID so that we can able to access & read your statement.
        </p>
        <form class="login-form-box register-page pricing-plan_modal-bottombox">            
          <v-row>
            <v-col>
              <v-btn class="blue-btn"
                @click="proceedAutoTrackDialogFirst">
                Proceed   
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </v-card-text>
      <v-card-text v-else>
        <p>With <b>“Auto Track”</b> your investments in NPS will be automatically updated. </p>
        <p>You need to sync emails where you receive Monthly Transaction Statement for your NPS account either from KFintech or Protean CRAs and start auto tracking your portfolio.</p>
        <p>You will receive emails from <b>KCRA@kfintech.com</b> with Subject line – “Monthly Transcation Statement for your NPS account with KFintech-CRA.” OR from <b class="tex_color">CRA@nsdl.co.in</b> with subject line – “Monthly Transcation Statement of your NPS account for the period DD-MMM-YYYY TO DD-MMM-YYYY” for NPS statement with Protean CRA</p>
        <p>You have to enable read permission for your email ID so that we can able to access & read your statement.
        </p>
        <form class="login-form-box register-page pricing-plan_modal-bottombox">            
          <v-row>
            <v-col>
              <v-btn class="blue-btn"
                @click="proceedAutoTrackDialogFirst">
                Proceed   
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
	</v-dialog>
</template>	
<script>
    import { Auth } from "aws-amplify";
    import Datepicker from 'vuejs-datepicker';
    export default {
 		components: {
		  Datepicker,
		},
	  	props: ['is_auto_sync_dialog_first_open_status', 'get_auto_sync_dialog_first_data', 'getDashboardType'],
	  	data: function () {
		    return { 
				  is_auto_sync_dialog_first_open:this.is_auto_sync_dialog_first_open_status,
          delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete-icon.png',
          dashboardType:this.getDashboardType
		    }
		},

    created(){

      console.log('second', this.dashboardType)

    },

		methods:{
			proceedAutoTrackDialogFirst(){
        this.$emit('allowAutoSyncDialogTwo', true); 
			},

			closeDialogFirst(status){
				this.$emit('allowAutoSyncDialogTwo', false); 
			}
		}
	}	
</script>
<style scoped>
  .tex_color{
  	  color: #0144AF !import;
  }
</style>    	